import { User, Settings } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";
import { Button } from "@/shared/ui/button";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { ScopeContextStorage } from "@/shared/lib/scope-storage";
import { secureSessionStorage } from "@/shared/lib/storage";
import { useLanguage } from "@/shared/hooks/use-language";

export const UserMenu = () => {
  const location = useLocation();
  const sessionIdFromState = location.state?.sessionId;
  const sessionId = sessionIdFromState || ScopeContextStorage.getCurrentSessionId();
  const { t } = useLanguage();
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    if (!sessionId) return;
    secureSessionStorage.getUserId(sessionId).then(setUserId).catch(() => {});
  }, [sessionId]);
  
  const handleLogout = () => {
    ScopeContextStorage.clearScopeContext();
    window.location.href = "/login";
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="w-10 h-10 rounded-full p-0 bg-primary/10 hover:bg-primary/20"
        >
          <User className="w-5 h-5 text-primary" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium">{t("menu.user")}</p>
            {userId && (
              <p className="text-xs text-muted-foreground">
                {userId}
              </p>
            )}
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild className="cursor-pointer">
          <Link to="/console/settings" data-testid="user-menu-settings">
            <Settings className="w-4 h-4 mr-2" />
            {t("menu.settings")}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="cursor-pointer text-destructive">
          <span>{t("menu.logout")}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
